import { defineComponent } from '@vue/composition-api'
import { get } from 'lodash'
export default defineComponent({
  name: 'TableHeaderRender',
  props: {
    renderfunc: {
      type: Function
    },
    index: { type: [String, Number], default: '' },
    column: {
      type: Object,
      default: () => {}
    }
  },
  render(h: Function) {
    // 自定义render
    // 只能返回一个Vnode节点

    if (!this.renderfunc) {
      return <span>{get(this.column, 'label')}</span>
    }

    const render: any = this.renderfunc
    const component = render(h, {
      index: this.index,
      column: this.column
    })
    return component
  }
})
